<app-search-field
  [value]="textValue"
  [debounceTime]="debounceModelChangeTimeMs"
  (debouncedValueChange)="setNewFilter($event)" />

@if (showCheckboxForEmptyValue) {
  <app-checkbox
    [(ngModel)]="filter.is_null"
    (checkedChange)="updateFilterChangeTime()">
    {{ translationForEmpty }}
  </app-checkbox>
}
